import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "fill",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 14.9384V1.06161C2 0.4753 2.51098 0 3.1413 0H5.8587C6.48902 0 7 0.4753 7 1.06161V14.9384C7 15.5247 6.48902 16 5.8587 16H3.1413C2.51098 16 2 15.5247 2 14.9384ZM9 14.9384V1.06161C9 0.4753 9.51098 0 10.1413 0H12.8587C13.489 0 14 0.4753 14 1.06161V14.9384C14 15.5247 13.489 16 12.8587 16H10.1413C9.51098 16 9 15.5247 9 14.9384Z",
      fill: "#212225"
    }, null, -1)
  ])))
}
export default { render: render }